import { GetStartedMicrocopyProps } from 'src/checkout/sections/GetStarted/GetStarted';
import { BadgeIllustration } from 'src/general/components/BadgeIllustration/BadgeIllustration';
import { BADGE } from 'src/general/components/BadgeIllustration/BadgeIllustration.type';
import { Button } from 'src/general/components/Button/Button';
import { formatNumber } from 'src/general/helpers/formatNumber';
import { GetStartedLocationModal } from '../GetStartedLocationModal/GetStartedLocationModal';
import styles from './GetStartedCarTile.module.scss';

type Props = {
  microcopy: GetStartedMicrocopyProps;
  price: number;
  onOpen: () => void;
};

const GetStartedUsp = ({ microcopy, price, onOpen }: Props) => {
  const { includedText, deliveryText, freeText, priceGstLabel, guaranteeText, warrantyText, nrmaText } = microcopy;

  const usps = [
    { icon: BADGE.SEVEN_DAY_RETURN, content: guaranteeText },
    { icon: BADGE.WARRANTY, content: warrantyText },
    { icon: BADGE.ROADSIDE_ASSISTANCE, content: nrmaText },
  ];

  return (
    <div className={styles.uspWrapper}>
      <div className={styles.uspContainer}>
        {usps.map(({ icon, content }) => (
          <div className={styles.usp} key={icon}>
            <BadgeIllustration icon={icon} shape="square" background="none" className={styles.icon} />
            <p className={styles.uspText}>{content}</p>
            <p className={styles.includedText}>{includedText}</p>
          </div>
        ))}
        <div className={styles.usp}>
          <BadgeIllustration icon={BADGE.DELIVERY} shape="square" background="none" className={styles.icon} />
          <div className={styles.deliveryContent}>
            <p className={styles.deliveryText}>{deliveryText}</p>
            <div className={styles.deliveryButtonContainer}>
              <GetStartedLocationModal microcopy={microcopy} />
            </div>
          </div>
          <p className={styles.includedText}>{freeText}</p>
        </div>
      </div>

      <div className={styles.totalContainer}>
        <h6>Total</h6>
        <div className={styles.priceContainer}>
          <h6>{formatNumber(price, { prepend: '$' })}</h6>
          <Button variant="link" size="small" onClick={onOpen} className={styles.priceGstLabel}>
            {priceGstLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GetStartedUsp;
